import { render, staticRenderFns } from "./detail_yhmh.vue?vue&type=template&id=3eec5f0c&scoped=true"
import script from "./detail_yhmh.vue?vue&type=script&lang=js"
export * from "./detail_yhmh.vue?vue&type=script&lang=js"
import style0 from "./detail_yhmh.vue?vue&type=style&index=0&id=3eec5f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec5f0c",
  null
  
)

export default component.exports